export const PRIMARY_COLOR = '#248cd4';
export const PRIMARY_HEADER_COLOR = '#000733';
export const ACCENT_COLOR = '#25d9b8';
export const TERTIARY_COLOR = '#00b687';
export const TERTIARY_COLOR_HOVER = '#009867';
export const TERTIARY_LIGHT_COLOR = 'rgba(0,198,155,0.6)';
export const FONT_COLOR = '#000733';
export const FONT_COLOR_SECONDARY = 'rgba(0, 7, 51, 0.6)';
export const FONT_COLOR_TERTIARY = 'rgba(0, 7, 51, 0.5)';
export const FONT_COLOR_QUARTERNARY = 'rgba(0, 7, 51, 0.8)';
export const FONT_COLOR_DISABLED = 'rgba(0, 7, 51, 0.24)';
export const CHECKBOX_BORDER_COLOR = '#C0C0C0';
export const WHITE_COLOR = '#fff';
export const ACTIVE_BUTTON_COLOR = '#2c3171';
export const BG_SECONDARY = 'rgba(7, 13, 88, 0.03)';
export const BORDER_COLOR = 'rgba(0, 7, 51, 0.08)';
export const X_GRID_POINT_COLOR = 'rgba(255,255,255,0.7)';
export const X_GRID_EMPHASIS_COLOR = 'rgba(255,255,255,0.25)';
export const LINK_COLOR = '#0D0B8C';
export const CLOSED_STATUS_COLOR = '#c62828';
export const PLANNED_STATUS_COLOR = '#f9a825';
export const ONGOING_STATUS_COLOR = '#6a6e9b';
export const PENDING_STATUS_COLOR = 'rgb(69, 161, 248)';
export const NO_RESULTS_STATUS_COLOR = 'rgb(146, 146, 146)';
export const COMPLETE_STATUS_COLOR = 'rgb(84, 173, 50)';
export const DANGER_COLOR = '#C62828FF';
export const MEDIUM_COLOR = '#F9A825FF';
export const DANGER_COLOR_DARK = '#900000';
export const MEDIUM_COLOR_DARK = '#da8400';
